import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function UnloadBreadCrumbs() {
    const location = useLocation();
    const vPathName = location.pathname;
    return (
        <div className="container-fluid p-0 mt-0 mb-3 breadcrumb">
            {vPathName === '/UnLoading' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive ">UnLoading Summary</span>
                </div>
            ) : vPathName === '/UnLoadingDetail' ? (
                <div className="d-flex">
                    <Link
                        to={"/UnLoading"}
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        UnLoading Summary
                    </Link>
                    <div>
                        <span className="breadcrumb-arrow-inactive">UnLoading Detail </span>
                    </div>
                </div>
            ) : vPathName === '/UnLoadingDetailItem' ? (
                <div className="d-flex">
                    <Link
                        to={"/UnLoading"}
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        UnLoading Summary
                    </Link>
                    <Link
                        to={"/UnLoadingDetail"}
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        UnLoading Detail
                    </Link>
                    <div>
                        <span className="breadcrumb-arrow-inactive">UnLoading Detail Item </span>
                    </div>
                </div>
            )
                : (
                    <></>

                )}
        </div>
    );
}

